export const CLOUDCHAT_SUPPORT_FEATURE_FLAG = 'cloudchat_support_widget';

export const CLOUDCHAT_SUPPORT_SLOT_ATTRIBUTE = 'data-cloudchat-support-slot';

const INTERNAL_EMAIL_DOMAIN = '@cloudhumans.com';

export const canShowCloudchatSupportWidget = ({
  accountId,
  email,
  isFeatureFlagEnabled,
} = {}) => {
  if (!accountId) return false;
  if ((email || '').toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN)) return true;
  if (typeof isFeatureFlagEnabled !== 'function') return false;
  return Boolean(isFeatureFlagEnabled(CLOUDCHAT_SUPPORT_FEATURE_FLAG));
};
